import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var delNoteRes;
export const delNoteTodo = createAsyncThunk('delNote', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    // console.log(val)

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/delete_note',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "note_id": val,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return delNoteRes = res.data
    } catch (error) {
        return delNoteRes = error.response.data
    }
})